<template>
	<div id="informations" class="w-full" :class="($route.name == 'public-entertainment') ? 'p-3': ''">
        <div class="logo" v-if="$route.name == 'public-entertainment'">
            <img :src="require('@/assets/images/logo/Logotipo_Verde.png')" alt="logo" class="w-10 mr-4 align-middle">
            <span style="color: #476061" class="logo-text -my-1 align-middle"><em>My</em> Vila Galé</span>
        </div>
        <div v-if="$route.name == 'public-entertainment'" class="flex my-5">
            <div class="w-4/5">
                <h1>{{ $t($route.meta.pageTrans) }}</h1>
            </div>
            <div v-if="$route.params.hotelId" class="w-1/5">
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
                    <span class="cursor-pointer flex i18n-locale">
                        <img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" />
                        <span class="hidden sm:block ml-2"></span>
                    </span>
                    <vs-dropdown-menu class="w-50 i18n-dropdown">
                        <vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
                        <vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
        </div>
        

		<div class="vx-row mt-5">

			<div class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base" v-for="(b, index) in blocks" :key="index">
                <vx-card>
                    <div slot="no-body">
                        <img v-if="b.image_path !== null" :src="b.image_path" alt="content-img" class="responsive card-img-top">
                        <img v-else :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                    </div>
                    <h5 class="mb-2 h-12">{{b.translation[0].title}}</h5>
                    <div class="justify-between flex-wrap">
                    	<a class="w-full" target="_blank" :href="b.translation[0].url">
					  		<vs-button type="gradient" class="w-full mt-6" color="#63C0BB" gradient-color-secondary="#91d2cf">{{$t('Ver_mais')}}</vs-button>
						</a>
                    </div>
                </vx-card>
            </div>
        </div>


		<div class="w-full">
			<hotelDropdown v-bind:append_to_body="false" v-bind:current_stay="hotel_id" v-on:onChangeHotel="onChangeHotel" :menus_page="false"></hotelDropdown>
		</div>


		<div class="vx-row mt-5" v-if="hotel_blocks.length != 0 && hotel_id != null && total_trans > 0">
			<div class="vx-col w-full sm:w-1/2 mb-base" :class="[$route.meta.category == 'information' ? 'lg:w-1/4' : 'lg:w-1/3']" v-for="(b, index) in hotel_blocks" :key="index" v-if="b.translation.length != 0">
                <vx-card>
                    <div slot="no-body">
                        <img v-if="b.image_path !== null" :src="b.image_path" alt="content-img" class="responsive card-img-top">
                        <img v-else :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                    </div>
                    <h5 class="" :class="[$route.meta.category == 'information' ? 'h-12 mb-2' : '']">{{b.translation[0].title}}</h5>
                    <div class="justify-between flex-wrap">
                    	<a class="w-full" target="_blank" :href="b.translation[0].url">
					  		<vs-button type="gradient" class="w-full mt-6" color="#63C0BB" gradient-color-secondary="#91d2cf">{{$t('Ver_mais')}}</vs-button>
						</a>
                    </div>
                </vx-card>
            </div>
		</div>
		<vx-card v-else-if="hotel_id != null" class="mt15">
			<div>
				<p align="center">{{$t('Nao_existem_conteudos_hotel_selecionado')}}</p>
			</div>
		</vx-card>

	</div>
</template>

<script>

import HotelDropdown from '@/views/components/HotelDropdown.vue';

export default {
	data() {
		return {
			blocks: '',
			hotel_blocks: '',
			user: '',
			hotel_id: null,
            language: '',
            token: '',
            total_trans: 0
		}
 	},
  	methods: {
		getBlocks(hotel_id, blocks = 'both') {
            this.$vs.loading();

            let is_staff = this.$user == null ? null : this.$user.is_staff;

            this.$api({
                method: 'get',
                url: '/myvilagale/informations/getBlocks',
                params: {
                    token: this.token,
                    hotel_id: hotel_id,
                    blocks: blocks,
                    category: this.$route.meta.category,
                    language: this.language,
                    is_staff: is_staff,
                },
            })
            .then((res) => {
                if(blocks == 'both'){
					this.blocks = res.data.blocks;
					this.hotel_blocks = res.data.hotel_blocks;
                    this.checkTotalTrans(this.hotel_blocks);
                }else if(blocks == 'blocks'){
					this.blocks = res.data.blocks;
                }else if(blocks == 'hotel_blocks'){
                	this.hotel_blocks = res.data.hotel_blocks;
                    this.checkTotalTrans(this.hotel_blocks);
                }
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
            })
            .then((res) => {
                this.$vs.loading.close();
            });
        },
        checkTotalTrans(hotel_blocks){
            let total = 0;
            for (let i = 0; i < hotel_blocks.length; i++) {
                total += hotel_blocks[i].translation.length;
            }

            this.total_trans = total;
        },
		onChangeHotel(newHotel) {
			this.hotel_id = newHotel;
			this.getBlocks(this.hotel_id, 'hotel_blocks');
            if(this.$route.name == 'public-entertainment') {
                this.$router.push({name: 'public-entertainment', params: {lang: this.$route.params.lang, hotelId: newHotel}});
            }
		},
		goToGetBlocks(){
			if (this.hotel_id == null) {
	        	this.getBlocks(this.hotel_id, 'blocks');
	        }else{
	        	this.getBlocks(this.hotel_id);
	        }
		}
	},
	created() {
		this.user = JSON.parse(window.localStorage.getItem('userSession'));

        this.hotel_id = null;
        this.token = process.env.VUE_APP_TOKEN;
        this.language = 'PT';

        if (typeof this.$route.params.hotelId !== 'undefined') {
            this.hotel_id = this.$route.params.hotelId;
            
            if (typeof this.$route.params.lang !== 'undefined') {
                this.language = this.$route.params.lang.toUpperCase();
            }
        }else if (this.user !== null) {
            this.language = this.$i18n.locale.toUpperCase();
            this.token = localStorage.getItem('usertoken');

            if (this.user.hotel.hotel_id) {
                this.hotel_id = this.user.hotel.hotel_id;
            }else{
                this.hotel_id = null;
            }
        }

        this.updateLocale(this.language.toLowerCase());
        this.goToGetBlocks();
	},
  	components: {
		HotelDropdown,
  	},
  	watch: {
        '$i18n.locale': function(new_val, old_val){
            this.updateLocale(new_val.toLowerCase());
            this.language = new_val.toUpperCase();
            this.goToGetBlocks();
        }
    }
}
</script>

<style>
	#informations .mt15 {
		margin-top: 15px;
	}
    #informations .logo-text{
        font-size: 26px;
        font-weight: 600;
        color: #4A4E4F;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
        font-family: 'Titillium Web',sans-serif;
    }
    #informations .vxCardFix{
        margin: 0 1rem !important;
    }
</style>

